import fetch from './fetch';

export function generateXLSX (query) {
  return fetch({
    url: '/xlsx',
    method: 'get',
    params: query
  })
}

export function generateDOCX (query) {
  return fetch({
    url: '/docx',
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/project.js